"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiGiftBox = /** @class */ (function (_super) {
    __extends(ApiGiftBox, _super);
    function ApiGiftBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_GIFT_NEW_ID = "/api/gift/create";
        _this.GET_GIFT_LIST = "/api/gift/list";
        _this.GET_GIFT = "/api/gift/get";
        _this.GET_GOODS_LIST = "/api/gift/goodsList";
        _this.UPDATE_GIFT = "/api/gift/set";
        _this.UPDATE_GIFT_SORT = "/api/gift/sort";
        _this.DELETE_GIFT = "/api/gift/delete";
        /**
         * 선물함 new id 생성
         * @param accesstoken
         * @param language
         * @returns
         */
        _this.getGiftNewId = function (accesstoken, language) {
            var data = {
                language: language,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                url: _this.GET_GIFT_NEW_ID,
                method: "post",
                data: data,
            });
            return config;
        };
        /**
         * 선물함 리스트
         * @param accesstoken
         * @param language
         */
        _this.getGiftList = function (accesstoken, language) {
            var data = {
                language: language,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_GIFT_LIST,
                data: data,
            });
            return config;
        };
        /**
         * gift 상세 정보
         * @param accesstoken
         * @param language
         * @param giftId
         * @returns
         */
        _this.getGift = function (accesstoken, language, giftId) {
            var data = {
                language: language,
                giftId: giftId,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_GIFT,
                data: data,
            });
            return config;
        };
        /**
         * gift에 설정된 gift 리스트 획득
         * @param accesstoken
         * @param giftId
         * @returns
         */
        _this.getGoodsList = function (accesstoken, giftId, language) {
            var params = {
                giftId: giftId,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken, language: language },
                method: "get",
                url: _this.GET_GOODS_LIST,
                params: params,
            });
            return config;
        };
        /**
         * gift 상세 정보 업데이트
         * @param accesstoken
         * @param request
         * @returns
         */
        _this.updateGift = function (accesstoken, request) {
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.UPDATE_GIFT,
                data: request,
            });
            return config;
        };
        /**
         * gift 정렬 update
         * @param accesstoken
         * @param language
         * @param giftIds
         * @returns
         */
        _this.updateGiftSort = function (accesstoken, language, giftIds) {
            var data = {
                language: language,
                giftIds: giftIds,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.UPDATE_GIFT_SORT,
                data: data,
            });
            return config;
        };
        /**
         * gift 삭제
         * @param accesstoken
         * @param language
         * @param giftId
         * @returns
         */
        _this.deleteGift = function (accesstoken, language, giftId) {
            var data = {
                language: language,
                giftId: giftId,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.DELETE_GIFT,
                data: data,
            });
            return config;
        };
        return _this;
    }
    ApiGiftBox.getInstance = function (initValue) {
        if (!ApiGiftBox.classInstance) {
            this.classInstance = new ApiGiftBox(initValue);
        }
        return this.classInstance;
    };
    return ApiGiftBox;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiGiftBox;
